<template>
  <section class="TcWelcome">
    <div class="container mx-auto">
      <div class="flex flex-col mx-auto max-w-5xl pt-3">
        <p class="help  text-center mb-3">En este espacio podrás solicitar Cita Previa e Inscribirte en eventos y actividades </p>
        <p class="instructions text-center max-w-2xl mx-auto">Introduce tu DNIe en el lector de tarjetas y pulsa en comenzar</p>
        <img src="/assets/img/img1.png" style="width: 327px;" class="mx-auto my-5"/>
        <div class="buttons flex flex-col gap-4 mx-auto max-w-xl w-full text-center">
          <button @click="click('login-dni')"><TcIcon class="h-10 w-10 mr-3" icon="card"></TcIcon> Entrar con DNI electrónico</button>
          <button @click="click('login')" class="btn-secondary"><TcIcon class="h-10 w-10 mr-3" icon="key"></TcIcon> Entrar con contraseña</button>
          <button @click="click('login-public')" class="btn-secondary"><TcIcon class="h-10 w-10 mr-3" icon="group"></TcIcon> Acceso público</button>
          <!--small class="help">Si no tienes DNI electrónico</small-->
        </div>
      </div>
      <!-- URL de la API que devuelve las noticias -->
      <NewsSlider/>
    </div>
  </section>
</template>

<script>
import TcIcon from './TcIcon.vue';
import NewsSlider from './NewsSlider.vue';

export default {
  name: 'TcWelcome',
  components: {
    TcIcon,
    NewsSlider
  },
  methods: {
    click: function(page) {
      this.$root.setPage(page);
    },
  }
}
</script>
